// This modal takes in and id and a type
// Right now, the types are either 'finance' or 'student'

import { createConfirmation } from 'react-confirm'
import ModalBody from "./ModalBody";

const modal = createConfirmation(ModalBody);

export default function (opts = {}) {
  if (typeof opts.type === 'undefined') {
    throw new Error('opts.type is required.');
  }
  
  return modal(opts);
}



// WEBPACK FOOTER //
// ./src/template/Modals/RegisterUser/index.js